import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LlwythwrService {

    ynLlwytho = new BehaviorSubject(false);

    constructor() { }
}
